import { ReportDistribution } from "constants/reports/distribution";
import { IFirstResponseTime, IFirstResponseTimePerEntity } from "services/api/report/interfaces";

import { ITicketFirstResponseTimeData } from "../interfaces";

import { ticketsTimeDeserializer } from "./time-deserializer";

type IFirstTimeResponseData = {
  data: {
    firstResponseTime: IFirstResponseTime;
    firstResponseTimePerTeam: IFirstResponseTimePerEntity;
    firstResponseTimePerAgent: IFirstResponseTimePerEntity;
  };
};

function mapToArray(data: IFirstResponseTimePerEntity): IFirstResponseTimePerEntity[] {
  return Object.entries(data).map(([id, values]) => ({
    id,
    ...values,
    total: values.averageSecondsToAssignment + values.averageSecondsToResponse,
  }));
}

export function ticketFirstResponseTimeDeserializer(
  { data }: IFirstTimeResponseData,
  distribution: ReportDistribution
): ITicketFirstResponseTimeData {
  const firstResponseTime = ticketsTimeDeserializer(data.firstResponseTime, "first response time", distribution);
  const assignmentAverage = firstResponseTime.summary[1].rawValue;
  const responseAverage = firstResponseTime.summary[2].rawValue;
  const firstResponseTimeAverage = firstResponseTime.summary[0].rawValue;

  const totalAverage = {
    id: "total",
    averageSecondsToAssignment: assignmentAverage,
    averageSecondsToResponse: responseAverage,
    total: firstResponseTimeAverage,
    count: 0,
  };

  return {
    firstResponseTime,
    firstResponseTimePerTeam: mapToArray({ ...data.firstResponseTimePerTeam, [totalAverage.id]: totalAverage }),
    firstResponseTimePerAgent: mapToArray({ ...data.firstResponseTimePerAgent, [totalAverage.id]: totalAverage }),
  };
}
